<template>
    <div>
        <el-card>
            
        </el-card>
    </div>
</template>

<script>
 import ImportTransJs from "./ImportTrans.js";

    export default ImportTransJs;
</script>




// WEBPACK FOOTER //
// src/components/ImportTrans/ImportTrans.vue